import { useLayoutEffect, useEffect } from 'react'

const TAILWIND_2XL_QUERY = '(min-width: 1536px)'
const DAY_WIDTH_SCALE_2XL = 1.0
const DAY_WIDTH_SCALE = 0.7

const GetTrainingTimelineItemWidthModifier = () => {
    if (typeof window !== 'undefined' && window.matchMedia(TAILWIND_2XL_QUERY).matches) {
        return DAY_WIDTH_SCALE_2XL
    }
    
    return DAY_WIDTH_SCALE
}

export default function TrainingTimelineViewport({ 
    viewportRef,
    setViewportWidth = () => {},
    setTrainingTimelineItemWidthModifier = () => {},
    children
}) {

    const DisablePageSwipeNavigation = () => {
        document.documentElement.style.overscrollBehaviorX = 'none'
        document.body.style.overscrollBehaviorX = 'none'
    }

    const RestorePageSwipeNavigation = () => {
        document.documentElement.style.overscrollBehaviorX = ''
        document.body.style.overscrollBehaviorX = ''
    }

    // Set viewport width on mount and when window size changes

    useLayoutEffect(() => {
        const UpdateViewportWidth = () => {
            setViewportWidth(viewportRef.current.clientWidth)
        }

        UpdateViewportWidth()

        const resizeObserver = new ResizeObserver(UpdateViewportWidth)

        resizeObserver.observe(viewportRef.current)

        return () => {
            resizeObserver.disconnect()
        }
    }, [])

    // Set training timeline item width modifier on mount and when window size changes

    useEffect(() => {
        const UpdateTrainingTimelineItemWidthModifier = () => {
            const newTrainingTimelineItemWidthModifier = GetTrainingTimelineItemWidthModifier()
            setTrainingTimelineItemWidthModifier(newTrainingTimelineItemWidthModifier)
            // console.log('Updated training timeline item width modifier to', newTrainingTimelineItemWidthModifier)
        }

        UpdateTrainingTimelineItemWidthModifier()

        const mediaQuery = window.matchMedia(TAILWIND_2XL_QUERY)

        mediaQuery.addEventListener('change', UpdateTrainingTimelineItemWidthModifier)

        return () => {
            mediaQuery.removeEventListener('change', UpdateTrainingTimelineItemWidthModifier)
        }
    }, [])

    // macOS trackpads navigate back / forward on a horizontal two finger swipe. The browser decides that when the gesture starts, from the
    // page's overscroll behavior, and once a gesture's first wheel event goes unclaimed the rest can't be cancelled. Turning it off only while
    // hovered missed swipes that started just outside the timeline, started vertically, or came before mouseenter fired (the timeline scrolled
    // under a still cursor), so horizontal overscroll stays off for the whole page while the timeline is mounted, and is restored on unmount

    useEffect(() => {
        DisablePageSwipeNavigation()
        return RestorePageSwipeNavigation
    }, [])

    return (
        <div 
            className="relative w-full overflow-hidden select-none cursor-ew-resize overscroll-x-none"
            ref={viewportRef}
        >
            {children}
        </div>
    )
}